<template>
  <div id="scores">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>Game Scores</h1>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Played At</th>
                <th class="text-left">Status</th>
                <th class="text-left">Round</th>
                <th class="text-left">Question</th>
                <th class="text-left">Won $</th>
                <th class="text-left">Won Q</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="score in scores" :key="score.last_played">
                <td>
                  <h4>{{ score.last_played | moment('timezone', timezone, " h:mma") }}</h4>
                  {{ score.last_played | moment('timezone', timezone, " Do MMMM YYYY") }}
                </td>
                <td>{{ getStatus(score.status) }}</td>
                <td>{{ score.game }}/{{ score.max_games }}</td>
                <td>{{ score.round }}/{{ score.max_rounds }}</td>
                <td>{{ getWinDollars(score.status, score.win_dollars) }}</td>
                <td>{{ getWinQuora(score.status, score.win_quora) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Scores",
  data() {
    return {
      scores: null,
      timezone: null
    };
  },
  mounted() {
    this.getTimezone();
    this.getScores();
  },
  computed: {},
  methods: {
    getScores() {
      if (this.scores === null) {
        this.$store.dispatch("retrieveScores").then(() => {
          this.scores = this.$store.getters.scores;
        });
      }
    },
    getTimezone() {
      this.timezone = this.$moment.tz.guess();
    },
    getStatus(status) {
        if(status == 'in_progress') {
            return "In Progress";
        } 
        return "Finished";
    },
    getWinDollars(status, winDollars) {
        if(status == 'in_progress') {
            return '-';
        } else {
            return winDollars;
        }
    },
    getWinQuora(status, winQuora) {
        if(status == 'in_progress') {
            return '-';
        } else {
            return winQuora;
        }
    }
  }
};
</script>

<style scoped>
.container.fill-height > .row {
  max-width: initial;
}
</style>